import { fade } from '@material-ui/core/styles';
import { makeStyles } from '@material-ui/styles';

/** Matches app button radius (see muiButtonOverrides.js); avoids pill-shaped inputs. */
const OUTLINED_RADIUS = 8;

/**
 * Shared outlined TextField look for brand detail fields (name, URL, etc.).
 */
export const useBrandOutlinedFieldStyles = makeStyles((theme) => ({
  outlinedField: {
    '& .MuiOutlinedInput-root': {
      borderRadius: OUTLINED_RADIUS,
      transition: theme.transitions.create(['border-color', 'border-width'], {
        duration: theme.transitions.duration.shorter,
      }),
      '& fieldset': {
        borderRadius: OUTLINED_RADIUS,
        borderColor: theme.palette.divider,
        borderWidth: 1,
      },
      '&:hover fieldset': {
        borderColor: theme.palette.text.secondary,
      },
      '&.Mui-focused fieldset': {
        borderColor: theme.palette.primary.main,
        borderWidth: 2,
      },
    },
  },
  /**
   * Read-only / derived value: distinct from editable fields.
   * Defined after `outlinedField` so these rules win when both class names are set.
   */
  outlinedFieldLocked: {
    '& .MuiOutlinedInput-root': {
      cursor: 'default',
      backgroundColor: fade(theme.palette.common.black, 0.025),
      '& fieldset': {
        borderStyle: 'dashed',
        borderColor: theme.palette.divider,
      },
      '&:hover fieldset': {
        borderColor: theme.palette.divider,
      },
      '&.Mui-focused fieldset': {
        borderColor: theme.palette.divider,
        borderWidth: 1,
      },
      '& input': {
        color: theme.palette.text.secondary,
        cursor: 'default',
        caretColor: 'transparent',
      },
      '& input:focus': {
        outline: 'none',
      },
    },
  },
}));
